const BACKEND_BASE_URL = "https://equip-rails-backend-api.herokuapp.com/";

export { BACKEND_BASE_URL };
